import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllClientsWithProjects,
  getByIdClient,
} from "src/thunks/clientProjects";
import {
  getAllItemsByProjectId,
  addNewDispatchOrder,
  editDispatchOrder,
  getDispatchOrderByIdAction,
} from "src/thunks/dispatchOrder";
import { addDispatchOrderValidationSchema } from "src/helpers/yup_schema";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Search, Close } from "@mui/icons-material";
import IconNewRecord from "src/assets/images/icon_newrecord.svg";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
  Select,
  Button,
  Divider,
} from "@mui/material";
import _ from "lodash";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  GetError,
  AddingZeroOnTime,
  isNumber,
  isValidateMail,
  convertIsoToLocalDateTime,
} from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";

export const DispatchForm = ({
  handleClose,
  editData,
  getAllDispatchData,
  currentPage,
  isDelivery,
  isCollection,
}) => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const dispatch = useDispatch();
  const { allItemsByDepotId, addNewDispatchOrderLoadingState } = useSelector((state) => state.dispatch);
  const lookupValues = useSelector((state) => state.lookup.data);

  /** hooks useState ----------------------------------------------------- **/
  const [projectArray, setProjectArray] = useState([]);
  const [projectManagersArray, setProjectManagersArray] = useState([]);
  const [DispatchOrderStateData, _DispatchOrderStateData] = useState({
    orderNo: "",
    type: "",
    dueDate: new Date(),
    time1: moment().hour(),
    time2: moment().minutes(),
    street: "",
    town: "",
    country: "",
    postcode: "",
    vrn: "",
    vehicleModel: "",
    driverContact: "",
    driverName: ""

  });
  const [selectedDepot, setSelectedDepot] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [filteredItemsArray, setFilteredItemsArray] = useState([]);
  const [selectedItemsArray, setSelectedItemsArray] = useState([]);
  const [orderNoError, setOrderNoError] = useState("");
  const [depotSelectError, setDepotSelectError] = useState("");
  const [addressError, setAddressError] = useState({
    street: "",
    town: "",
    country: "",
    postcode: "",
    phone: null,
    driverContact: null,
    email: null,
  });
  const [highlightedRow, setHighlightedRow] = useState(null);
  const [clientsArray, setClientsArray] = useState([]);

  // Filter clients based on clientIds
  const filteredClients = (clientData) => {
    return clientData.filter((client) => clientIds?.includes(client?.id));
  };
  const {
    register,
    control,
    handleSubmit,
    clearErrors,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(addDispatchOrderValidationSchema),
    defaultValues: {
      email: "",
      client: null,
      project: null,
    },
  });

  /** Variable declarations ----------------------------------------------------- **/
  let { id } = useParams();
  let damageCount =_.filter(selectedItemsArray, (d) => d.condition === "Damaged")?.length || 0;
  let unitsCount = _.sumBy(selectedItemsArray, (d) => d.quantity) || 0;
  const ProjectManagerData = JSON.parse(localStorage.getItem("userDetails"));

  // Extract clientIds from the projects array and remove duplicates
  const clientIds = [...new Set(ProjectManagerData?.projects?.map((project) => project.clientId)),];
  const projectManagerFName = ProjectManagerData?.firstName || " ";
  const projectManagerLName = ProjectManagerData?.lastName || "";

  const sortProjectArray = _.orderBy(
    _.map(projectArray, (d) => {
      return {
        ...d,
        newName: d?.name || d?.projectName,
      };
    }),
    ["newName"],
    ["asc"]
  );

  const sortProjectManagersArray = _.orderBy(
    _.map(projectManagersArray, (d) => {
      return {
        ...d,
        newName: d.firstName + " " + d.lastName,
      };
    }),
    ["newName"],
    ["asc"]
  );

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    if (editData) {
      resetDataForEditRecord();
    } else {
      resetPMData();
    }
  }, []);


  /** handler functions--------------------------------------------------- **/
  const loadDepotRelatedData = async () => {
    try {
      let resultData = await dispatch(
        getAllItemsByProjectId(editData?.projectId)
      ).unwrap();
      if (resultData) {
        resultData = resultData.map((depot) => {
          let newDepot = { ...depot };
          newDepot.items = newDepot.items.map((item) => {
            return {
              ...item,
              availableQty: item.currentQuantity - item.onHoldQuantity,
            };
          });
          return newDepot;
        });
        let found = _.find(
          resultData || [],
          (d) => d.depotId === editData?.depotId
        );
        let newData = _.map(found?.items || [], (item) => {
          return {
            ...item,
            condition: lookupValues.find((v) => v.id === item.conditionId).name,
            storage: lookupValues.find((v) => v.id === item.storageId).name,
          };
        });
        setFilteredItemsArray([...newData]);
        let deliveryItems = [...editData?.deliveryItems];
        deliveryItems = deliveryItems.map((item) => {
          return {
            ...item,
            condition: lookupValues.find((v) => v.id === item.conditionId).name,
            storage: lookupValues.find((v) => v.id === item.storageId).name,
          };
        });
        deliveryItems = deliveryItems.map((di) => {
          return { ...di, id: di.id ? di.id : di.itemId };
        });
        setSelectedItemsArray(deliveryItems || []);
      }
    } catch (error) {
      // toast.error(error.response.data.detail || "something issue");
    }
  };

  const resetDataForEditRecord = async () => {
    const res = await dispatch(getAllClientsWithProjects()).unwrap();
    const filteredIndClient = _.filter(res, (d) => d.id === editData?.clientId)
    const filteredData = _.orderBy(filteredClients(res), ["name"], ["asc"]);
    const filteredIndProject = _.find(filteredIndClient[0]?.projects, (d) => d.id === editData?.projectId)
    setClientsArray(filteredData);
    const filteredProjectList = await filterProjectArrayFromClient(editData?.clientId)
    reset({
      client: filteredIndClient?.[0] || "",
      project: filteredIndProject || "",
    });
    setSelectedDepot(editData?.depotId);
    // ADDED 3 LINES TO SHOW TIME LOCAL INSTEAD UTC
    let localTime = convertIsoToLocalDateTime(
      `${editData?.dueDate?.split("T")[0]}T${editData?.dueTime ? editData?.dueTime : "00:00:00"
      }.00Z`,
      "DD-MMM-YYYY HH:mm"
    );
    let newLocalTime = moment(localTime).format("HH:mm:ss");
    let newLocalDate = moment(localTime).format("YYYY-MM-DD");
    _DispatchOrderStateData({
      ...DispatchOrderStateData,
      type: lookupValues?.find((lv) => lv.id == editData?.typeId)?.name || "",
      orderNo: editData?.orderNo || "",
      projectManagerId: editData?.projectManager?.id || "",
      dueDate: newLocalDate ? new Date(newLocalDate) : new Date(),
      time1:
        (newLocalTime?.split(":")[0] &&
          parseInt(newLocalTime?.split(":")[0], 10).toString()) ||
        moment().hour(),
      time2:
        (newLocalTime?.split(":")[1] &&
          parseInt(newLocalTime?.split(":")[1], 10).toString()) ||
        moment().minutes(),
      name: editData?.contactName || "",
      email: editData?.contactEmail || "",
      phone: editData?.contactPhone || "",
      status: editData.statusId,
      vrn: editData?.vrn,
      vehicleModel: editData?.vehicleModel,
      driverName: editData?.driverName,
      driverContact: editData?.driverContact,

      street: editData?.address?.street1 || "",
      town: editData?.address?.city || "",
      country: editData?.address?.country || "",
      postcode: editData?.address?.zip || "",
    });
    loadDepotRelatedData();
  };

  const filterProjectArrayFromClient = async (id) => {
    const filteredProjectData = _.filter(
      ProjectManagerData?.projects,
      (d) => d.clientId === id
    );
    const filteredProjects = _.orderBy(filteredProjectData, ["name"], ["asc"]);
    setProjectArray(filteredProjects);
    return filteredProjectData;
  }

  const resetPMData = async () => {
    const result = await dispatch(
      getByIdClient({ id: ProjectManagerData?.projects[0]?.clientId })
    ).unwrap();
    const res = await dispatch(getAllClientsWithProjects()).unwrap();
    const filteredData = _.orderBy(filteredClients(res), ["name"], ["asc"]);
    setClientsArray(filteredData);
    const filteredProjectList = await filterProjectArrayFromClient(filteredData?.[0]?.id)
    setValue("client", filteredData[0]);
    setValue("project", filteredProjectList[0]);

    setTimeout(async () => {
      _DispatchOrderStateData({
        ...DispatchOrderStateData,
        projectManagerId: ProjectManagerData?.id,
        street: ProjectManagerData?.projects[0]?.address?.street1 || "",
        town: ProjectManagerData?.projects[0]?.address?.city || "",
        country: ProjectManagerData?.projects[0]?.address?.country || "",
        postcode: ProjectManagerData?.projects[0]?.address?.zip || "",
        name:
          `${ProjectManagerData?.firstName} ${ProjectManagerData?.lastName}` ||
          "",
        email: ProjectManagerData?.email || "",
        phone: ProjectManagerData?.phoneNumber || "",
      });
      try {
        await dispatch(
          getAllItemsByProjectId(filteredProjectList?.[0]?.id)
        ).unwrap();
      } catch (error) {
        toast.error(
          GetError(error?.response?.data?.errors) || "something issue"
        );
      }
    }, 100);
  };

  function validateNumber(input) {
    var re = /^[0-9 -]*$/;
    return re.test(input);
  }

  // -----------------------
  const AllChangeHandler = (label, value) => {
    setAddressError({ ...addressError, [label]: "" });
    allOnChangeHandler(label, value);
  };

  const newFilteredArray = _.filter(filteredItemsArray, (value) => {
    return value.itemNumber.toLowerCase().includes(searchValue.toLowerCase());
  });

  const allOnChangeHandler = (title, value) => {
    if (title == "driverContact") {
      if (!validateNumber(value)) {
        setAddressError({
          ...addressError,
          driverContact: "Enter Valid Contact no",
        });
      } else {
        setAddressError({ ...addressError, driverContact: null });
      }
    }

    if (title == "email") {
      if (value != "") {
        setAddressError({ ...addressError, email: null });
      } else {
        setAddressError({
          ...addressError,
          email: "Email is Required",
        });
      }
      if (!isValidateMail(value)) {
        setAddressError({
          ...addressError,
          email: "Enter Valid Email",
        });
      }
    }

    if (title == "phone") {
      if (value != "") {
        setAddressError({ ...addressError, phone: null });
      } else {
        setAddressError({
          ...addressError,
          phone: "Phone is Required",
        });
      }
      if (!validateNumber(value)) {
        setAddressError({
          ...addressError,
          phone: "Enter Valid Phone",
        });
      }
    }
    _DispatchOrderStateData({ ...DispatchOrderStateData, [title]: value });
  };

  const streetChange = (value) => {
    setAddressError({ ...addressError, street: "" });
    allOnChangeHandler("street", value);
  };
  const townChange = (value) => {
    setAddressError({ ...addressError, town: "" });
    allOnChangeHandler("town", value);
  };
  const countryChange = (value) => {
    setAddressError({ ...addressError, country: "" });
    allOnChangeHandler("country", value);
  };
  const postcodeChange = (value) => {
    setAddressError({ ...addressError, postcode: "" });
    allOnChangeHandler("postcode", value);
  };

  const RandomeReturnNumberGenrate = (string, len, string1, len1) => {
    return string + makeReturnId1(len) + string1 + makeReturnId(len1);
  };

  function makeReturnId1(length) {
    let result = "";
    const characters = "0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  function makeReturnId(length) {
    let result = "";
    const characters = "0123456789ABCDEFGHIJKLMNOPQRSTVVWXYZ";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const handleOrderTypeChange = (e) => {
    setOrderNoError("");
    if (e.target.value === "Delivery") {
      _DispatchOrderStateData({
        ...DispatchOrderStateData,
        type: e.target.value,
        orderNo: RandomeReturnNumberGenrate("DOO", 2, "/", 6),
      });
    } else {
      _DispatchOrderStateData({
        ...DispatchOrderStateData,
        type: e.target.value,
        orderNo: RandomeReturnNumberGenrate("COO", 2, "/", 6),
      });
    }
    clearErrors("radio");
  };

  /* This method is used to assign a value to the state of a client Name. */
  const handleClientNameChange = async (values) => {
    allOnChangeHandler("clientId", values?.id);
    setValue("project", null);
    setTimeout(() => {
      allOnChangeHandler("projectId", null);
    }, 200);
    await filterProjectArrayFromClient(values?.id)
  };



  const handleProjectNameChange = async (values) => {
    let DispatchOrderStateData1 = {
      ...DispatchOrderStateData,
      street: values?.address?.street1 || "",
      town: values?.address?.city || "",
      country: values?.address?.country || "",
      postcode: values?.address?.zip || "",
      projectId: values?.id,
    };
    _DispatchOrderStateData({
      ...DispatchOrderStateData1,
    });
    clearErrors("project");
    clearErrors("projectManager");
    try {
      await dispatch(getAllItemsByProjectId(values?.id)).unwrap();
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
    setProjectManagersArray(values.users ? values.users : []);
    setSelectedDepot(null);
    setFilteredItemsArray([]);
    setSelectedItemsArray([]);
  };

  const getDispatchOrderEditDataFunc = async () => {
    try {
      await dispatch(getDispatchOrderByIdAction({ id: id || "22" })).unwrap();
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const checkAddress = () => {
    let errors = {};
    ["street", "town", "country", "postcode", "name", "email", "phone"].map(
      (d) => {
        if (!DispatchOrderStateData[`${d}`]) {
          errors[`${d}`] = `Please add ${d} here`;
        } else {
          delete errors[`${d}`];
        }
        return "";
      }
    );
    return errors;
  };

  const onDispatchOrderFormSubmitHandler = async (data) => {
    if (selectedItemsArray.length <= 0) {
      toast.error("Please add delivery items here")
    }
    if (
      DispatchOrderStateData.orderNo === "" ||
      DispatchOrderStateData.orderNo === undefined
    ) {
      setOrderNoError("Please add order no here");
    }
    if (selectedDepot === "" || selectedDepot === undefined) {
      setDepotSelectError("Please select depot here");
    }
    let errors = {};
    if (DispatchOrderStateData.type === "Delivery") {
      errors = checkAddress();
      setAddressError({
        ...addressError,
        ...errors,
      });
    } else {
      setAddressError({
        ...addressError,
        street: "",
        town: "",
        country: "",
        postcode: "",
      });
    }
    clearErrors("radio");

    let newData = { ...DispatchOrderStateData };
    newData.typeId = lookupValues.find((v) => v.name === newData.type).id;

    let time = moment.utc(new Date(moment(newData.dueDate).format(
      "YYYY-MM-DD"
    ) + ' ' + `${AddingZeroOnTime(
      newData?.time1 || "00"
    )}:${AddingZeroOnTime(newData?.time2 || "00")}:35`));

    newData["dueDate"] = moment(time).format(
      "YYYY-MM-DD"
    );
    if (newData.time1 && newData.time2) {
      newData["dueTime"] = moment(time).format("HH:mm:ss");
      delete newData.time1;
      delete newData.time2;
    }
    newData["clientId"] = data?.client?.id;
    newData["projectId"] = data?.project?.id;
    newData["contactName"] = DispatchOrderStateData?.name;
    newData["contactPhone"] = (DispatchOrderStateData?.phone).toString();
    newData["contactEmail"] = DispatchOrderStateData?.email;
    newData["depotId"] = selectedDepot;
    newData["typeName"] = DispatchOrderStateData.type
    newData["ClientName"] = data?.client?.name
    newData["projectName"] = data?.project?.name
    newData["role"] = ProjectManagerData?.roles
    newData["vrn"] = DispatchOrderStateData.vrn
    newData["vehicleModel"] = DispatchOrderStateData.vehicleModel
    newData["driverName"] = DispatchOrderStateData.driverName
    newData["driverContact"] = DispatchOrderStateData.driverContact

    const updatedItemsArray =
      selectedItemsArray &&
      selectedItemsArray[0] &&
      selectedItemsArray.map((item, index) => {
        return {
          deliveryItemId: item.deliveryItemId ?? 0,
          deliveryOrderId: item.deliveryOrderId ?? 0,
          itemId: item.id,
          quantity: item.quantity,
        };
      });

    newData["deliveryItems"] = updatedItemsArray;

    newData["address"] = {
      street1: DispatchOrderStateData.street,
      country: DispatchOrderStateData.country,
      city: DispatchOrderStateData.town,
      zip: DispatchOrderStateData.postcode,
    };
    if (Object.keys(errors).length === 0) {
      if (
        !editData &&
        DispatchOrderStateData.orderNo !== "" &&
        selectedDepot !== "" &&
        Object.keys(errors).length === 0 &&
        selectedItemsArray.length > 0
      ) {
        try {
          newData.statusId = newData?.status ? newData?.status : 7;
          let result = await dispatch(addNewDispatchOrder(newData)).unwrap();
          if (result) {
            setTimeout(() => {
              dispatch(getAllNofificationForDashboard(1, 20));
            }, 2000);
            getAllDispatchData(currentPage, isDelivery, isCollection)
            toast.success(toastMessages.dispatchAdded);
            handleClose();
          }
        } catch (err) {
          toast.error(GetError(err?.response?.data?.errors) || "something issue");
        }
      } else if (editData) {
        if (
          DispatchOrderStateData.orderNo !== "" &&
          selectedDepot !== "" &&
          Object.keys(errors).length === 0 &&
          selectedItemsArray.length > 0) {
          try {
            newData.statusId = newData?.status == 8 ? 7 : newData?.status;
            let req = {
              ...newData,
              id: id,
              projectId: newData.projectId,
              clientId: newData.clientId,
              depotId: newData.depotId,
              orderNo: newData.orderNo,
              projectManagerId: newData.projectManagerId,
              dueDate: newData.dueDate,
              dueTime: newData.dueTime,
              status: newData.status,
              deliveryItems: newData.deliveryItems,
              type:
                typeof newData.type === "string"
                  ? lookupValues.find(
                    (lv) =>
                      lv.name === newData.type && lv.typeName === "DeliveryType"
                  )?.id
                  : newData.type,

              deliveryOrderRemarks: "",
            };
            let result = await dispatch(
              editDispatchOrder({
                ...req,
              })
            ).unwrap();
            if (result) {
              setTimeout(() => {
                dispatch(getAllNofificationForDashboard(1, 20));
              }, 2000);
              getDispatchOrderEditDataFunc();
              toast.success(toastMessages.dispatchEdited);
              handleClose();
            }
          } catch (error) {
            toast.error(GetError(error?.response?.data?.errors) || "something issue");
          }
        }
      } else {
      }
    }
  };

  const handleDepotNameChange = (target) => {
    setSelectedDepot(target);
    setDepotSelectError("");
    allOnChangeHandler("depotId", target);
    let found = {
      ...allItemsByDepotId.find(function (obj) {
        return obj.depotId === target;
      }),
    };

    found.items = found?.items.map((item) => {
      return {
        ...item,
        condition: lookupValues.find((v) => v.id === item.conditionId).name,
        storage: lookupValues.find((v) => v.id === item.storageId).name,
      };
    });
    setFilteredItemsArray(found?.items);
    setSelectedItemsArray([]);
  };

  const handleSearchInputChange = (e) => {
    const searchText = e.target.value;
    setSearchValue(searchText);
  };

  const handleClearSearchText = () => {
    handleSearchInputChange({ target: { value: "" } });
  };

  const handleAddItemClick = (itemId, index, itemObject) => {
    const cloneFilteredData = _.cloneDeep(filteredItemsArray);
    let FindIncrementData = _.findIndex(
      cloneFilteredData,
      (d) => d.id === itemId
    );

    let loadingUnit = cloneFilteredData[FindIncrementData]["loadingUnit"];

    let cloneSelectedItemsArray = _.cloneDeep(selectedItemsArray);
    let FindLoadingDatandex = _.findIndex(
      cloneSelectedItemsArray,
      (d) => d.id === itemId
    );

    if (loadingUnit > 0) {
      setHighlightedRow(null);
      if (FindLoadingDatandex !== -1) {
        cloneSelectedItemsArray[FindLoadingDatandex]["quantity"] =
          (cloneSelectedItemsArray[FindLoadingDatandex]?.quantity || 0) +
          cloneFilteredData[FindIncrementData].loadingUnit;
        setSelectedItemsArray([...cloneSelectedItemsArray]);
      } else {
        let newData = {
          ...itemObject,
          quantity: cloneFilteredData[FindIncrementData].loadingUnit,
        };
        setSelectedItemsArray([...cloneSelectedItemsArray, { ...newData }]);
      }
      cloneFilteredData[FindIncrementData]["availableQty"] =
        (cloneFilteredData[FindIncrementData]?.availableQty || 0) -
        (cloneFilteredData[FindIncrementData]?.loadingUnit || 0);
      cloneFilteredData[FindIncrementData]["loadingUnit"] = 0;
      let newOne = _.filter(cloneFilteredData, (d) => d.availableQty);
      setFilteredItemsArray([...newOne]);
    } else {
      setHighlightedRow(index);
    }
  };

  const handleRemoveItemIconClickFromTable = (item) => {
    const cloneFilteredData = _.cloneDeep(filteredItemsArray);
    let FindIncrementData = _.findIndex(
      cloneFilteredData,
      (d) => d.id === item?.id
    );

    let cloneSelectedItemsArray = _.cloneDeep(selectedItemsArray);
    let FindLoadingDatandex = _.findIndex(
      cloneSelectedItemsArray,
      (d) => d.id === item?.id
    );

    if (FindIncrementData !== -1) {
      cloneFilteredData[FindIncrementData]["availableQty"] =
        cloneFilteredData[FindIncrementData]["availableQty"] +
        cloneSelectedItemsArray[FindLoadingDatandex]["quantity"];
      setFilteredItemsArray([...cloneFilteredData]);
    } else {
      let newone = {
        ...cloneSelectedItemsArray[FindLoadingDatandex],
        loadingUnit: 0,
        availableQty: cloneSelectedItemsArray[FindLoadingDatandex]["quantity"],
      };
      setFilteredItemsArray([...filteredItemsArray, { ...newone }]);
    }
    let filterData = _.filter(selectedItemsArray, (d) => d.id !== item?.id);
    setSelectedItemsArray([...filterData]);
  };

  const handleRemoveQuantityonedit = (quantity, itemId) => {
    const cloneSelectedItemsArray = _.cloneDeep(selectedItemsArray);
    let findInderselectedArray = _.findIndex(
      cloneSelectedItemsArray,
      (d) => d.id === itemId.id
    );

    cloneSelectedItemsArray[findInderselectedArray]["quantity"] = parseInt(
      quantity || 0
    );

    const clonefilteredItemsArray = _.cloneDeep(filteredItemsArray);
    let findInderCloneFilteredItemsArray = _.findIndex(
      clonefilteredItemsArray,
      (d) => d.id === itemId.id
    );

    if (findInderCloneFilteredItemsArray !== -1) {
      let quantitys = parseInt(
        clonefilteredItemsArray[findInderCloneFilteredItemsArray]
          ?.availableQty +
        parseInt(itemId?.quantity || 0) -
        parseInt(quantity || 0)
      );
      let orgQuantity = parseInt(
        clonefilteredItemsArray[findInderCloneFilteredItemsArray]
          ?.availableQty + parseInt(itemId?.quantity || 0)
      );
      if (orgQuantity >= parseInt(quantity || 0))
        if (Math.sign(quantitys) === 1) {
          clonefilteredItemsArray[
            findInderCloneFilteredItemsArray
          ].availableQty = quantitys;
          clonefilteredItemsArray[
            findInderCloneFilteredItemsArray
          ].orgQuantity = orgQuantity;
          setFilteredItemsArray([...clonefilteredItemsArray]);
          if (orgQuantity > parseInt(quantity || 0)) {
            setSelectedItemsArray([...cloneSelectedItemsArray]);
          }
        } else if (Math.sign(quantitys) == 0) {
          let data = _.filter(filteredItemsArray, (d) => d.id !== itemId?.id);
          setFilteredItemsArray([...data]);
          setSelectedItemsArray([...cloneSelectedItemsArray]);
        } else {
        }
    } else {
      let quantitys = itemId.quantity - quantity;
      if (Math.sign(quantitys) === 1) {
        let newArray = {
          ...itemId,
          availableQty: quantitys,
          loadingUnit: 0,
          orgQuantity: itemId.quantity,
        };
        if (newArray.orgQuantity > parseInt(quantity || 0)) {
          setSelectedItemsArray([...cloneSelectedItemsArray]);
        }
        setFilteredItemsArray([...filteredItemsArray, { ...newArray }]);
      }
    }
  };

  const handleKeyPress = (e) => {
    const keyCode = e.which || e.keyCode;
    if (keyCode === 189 || keyCode === 109) {
      e.preventDefault();
    }
  };

  return (
    <>
      <div className="dispatch-form">
        <form onSubmit={handleSubmit(onDispatchOrderFormSubmitHandler)}>
          <div className="row mb-3 pb-2">
            <div className="col-md-12 col-lg-6">
              <div className="row d-flex align-items-center mb-3 mb-md-0">
                <div className="col-md-5 d-flex flex-column">
                  <TextField
                    label="ORDER NO."
                    variant="standard"
                    id="standard-basic"
                    style={{ height: 42, width: "100%" }}
                    value={DispatchOrderStateData.orderNo}
                    InputProps={{
                      readOnly: true,
                      disableUnderline: true,
                    }}
                  />
                  {/* <span className="errors-msg-shown-for-goodsin">{orderNoError && orderNoError}</span> */}
                </div>

                <div className="col-md-7 d-flex flex-column justify-content-end order-type-radio-buttons-class">
                  <div className="d-flex">
                    <input
                      className="me-2"
                      type="radio"
                      id="type1"
                      name="orderType"
                      value="Delivery"
                      onChange={(e) => handleOrderTypeChange(e)}
                      checked={DispatchOrderStateData.type === "Delivery"}
                    />
                    <label
                      className="me-3 radio-buttons-input-style"
                      style={{ position: "initial" }}
                      htmlFor="type1"
                    >
                      DELIVERY
                    </label>
                    <input
                      className="me-2"
                      type="radio"
                      id="type2"
                      name="orderType"
                      value="ClientCollection"
                      onChange={(e) => handleOrderTypeChange(e)}
                      checked={
                        DispatchOrderStateData.type === "ClientCollection"
                      }
                    />
                    <label
                      className="me-2 radio-buttons-input-style"
                      style={{ position: "initial" }}
                      htmlFor="type2"
                    >
                      COLLECTION
                    </label>
                  </div>
                  <div>
                    <span className="errors-msg-shown-for-goodsin">
                      {orderNoError && orderNoError}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6">
              <Controller
                name="client"
                control={control}
                render={({ field }) => {
                  return (
                    <Autocomplete
                      {...field}
                      options={clientsArray}
                      getOptionLabel={(item) =>
                        item.name ? item.name : "" || ""
                      }
                      isOptionEqualToValue={(option, value) => {
                        return option.name === value?.name;
                      }}
                      onChange={(event, newValue) => {
                        console.log("onchange", newValue);
                        field.onChange(newValue);
                        handleClientNameChange(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="CLIENT"
                          error={!!errors.client}
                          helperText={
                            errors.client ? errors.client.message : ""
                          }
                        />
                      )}
                    />
                  );
                }}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-7 col-lg-6 mb-2 pb-2">
              <Controller
                name="project"
                control={control}
                render={({ field }) => {
                  return (
                    <Autocomplete
                      {...field}
                      options={sortProjectArray}
                      getOptionLabel={(item) => item?.name || ""}
                      isOptionEqualToValue={(option, value) => {
                        return option.name === value.name;
                      }}
                      onChange={(event, newValue) => {
                        console.log("onchange", newValue);
                        field.onChange(newValue);
                        handleProjectNameChange(newValue)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="PROJECT"
                          error={!!errors.project}
                          helperText={
                            errors.project ? errors.project.message : ""
                          }
                        />
                      )}
                    />
                  );
                }}
              />
            </div>

            <div className="col-md-5 col-lg-6 mb-2 pb-2">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={sortProjectManagersArray}
                defaultValue={{
                  firstName:
                    editData?.projectManager?.firstName ||
                    projectManagerFName ||
                    "",
                  lastName:
                    editData?.projectManager?.lastName ||
                    projectManagerLName ||
                    "",
                }}
                getOptionLabel={(item) =>
                  item.firstName || item.lastName
                    ? item.firstName + " " + item.lastName
                    : ""
                }
                disabled={projectManagerFName !== " " ? true : false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="PROJECT MANAGER"
                    variant="standard"
                    id="standard-basic"
                    style={{ height: 42 }}
                  />
                )}
              />
            </div>
          </div>

          <div className="row">
            <span className="due-time-text-style my-2">
              DELIVERY DUE / COLLECTION PICK UP
            </span>
          </div>

          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-sm-12 col-md-6">
              <div className="row d-flex">
                <div className="col-6 col-sm-6 col-md-6">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Date"
                      value={DispatchOrderStateData.dueDate}
                      onChange={(newValue) =>
                        allOnChangeHandler("dueDate", newValue)
                      }
                      className="DatePickerOutline"
                      variant="standard"
                      id="standard-basic"
                      inputFormat="dd-MM-yyyy"
                      format="dd.MM.yyyy"
                    />
                  </LocalizationProvider>
                </div>
                <div className="col-6 col-sm-6 col-md-6">
                  <select
                    value={DispatchOrderStateData.time1}
                    onChange={({ target }) =>
                      allOnChangeHandler("time1", target.value)
                    }
                    style={{
                      textAlign: "center",
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                      borderBottom: "1px solid #5e89e7",
                      height: 42,
                    }}
                  >
                    {[...Array(24)].map((d, index) => {
                      const formattedValue = index.toString().padStart(2, "0");
                      return (
                        <option key={index} value={index}>
                          {formattedValue}
                        </option>
                      );
                    })}
                  </select>
                  :
                  <select
                    value={DispatchOrderStateData.time2}
                    onChange={({ target }) =>
                      allOnChangeHandler("time2", target.value)
                    }
                    style={{
                      textAlign: "center",
                      marginLeft: 3,
                      borderTop: 0,
                      borderLeft: 0,
                      borderRight: 0,
                      borderBottom: "1px solid #5e89e7",
                      height: 42,
                    }}
                  >
                    {[...Array(60)].map((d, index) => {
                      const formattedValue = index.toString().padStart(2, "0");
                      if (index === 0) {
                        return <option key={index}>{"00"}</option>;
                      }
                      // return <option key={index}>{index}</option>;
                      return (
                        <option key={index} value={index}>
                          {formattedValue}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6"></div>
          </div>

          <div className="d-flex mt-4">
            <span className="due-time-text-style">DELIVERY ADDRESS</span>
            {DispatchOrderStateData.type === "ClientCollection" && (
              <span className="due-time-text-style ms-2"> (OPTIONAL)</span>
            )}
          </div>

          <div className="row m-0 mt-2">
            <TextField
              className="depot-form-textfields-style"
              onChange={({ target }) => streetChange(target.value)}
              value={DispatchOrderStateData.street || ""}
              name="street"
              label="STREET"
              variant="standard"
            />
            <span className="errors-msg-shown-for-goodsin depotform-street-class">
              {addressError?.street || ""}
            </span>
          </div>

          <div className="row mt-3">
            <div className="col-md-4">
              <TextField
                className="depot-form-textfields-style"
                onChange={({ target }) => townChange(target.value)}
                label="TOWN"
                variant="standard"
                value={DispatchOrderStateData.town || ""}
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError?.town || ""}
              </div>
            </div>

            <div className="col-md-4">
              <TextField
                className="depot-form-textfields-style"
                id="standard-basic"
                label="COUNTRY"
                onChange={({ target }) => countryChange(target.value)}
                variant="standard"
                value={DispatchOrderStateData.country || ""}
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError?.country || ""}
              </div>
            </div>
            <div className="col-md-4">
              <TextField
                className="depot-form-textfields-style"
                onChange={({ target }) => postcodeChange(target.value)}
                id="standard-basic"
                label="POSTCODE"
                variant="standard"
                value={DispatchOrderStateData.postcode || ""}
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError?.postcode || ""}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <span className="due-time-text-style">CONTACT PERSON</span>
          </div>

          <div className="row mt-3">
            <div className="col-md-4">
              <TextField
                className="depot-form-textfields-style"
                onChange={({ target }) =>
                  AllChangeHandler("name", target.value)
                }
                value={DispatchOrderStateData.name || ""}
                // {...register("name")}
                id="standard-basic"
                label="NAME"
                variant="standard"
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError.name && addressError.name}
              </div>
            </div>

            <div className="col-md-4">
              <TextField
                className="depot-form-textfields-style"
                // {...register("email")}
                onChange={({ target }) =>
                  AllChangeHandler("email", target.value)
                }
                value={DispatchOrderStateData.email || ""}
                id="standard-basic"
                label="EMAIL"
                variant="standard"
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError.email && addressError.email}
              </div>
            </div>
            <div className="col-md-4">
              <TextField
                type="string"
                className="depot-form-textfields-style"
                // {...register("phone")}
                onChange={({ target }) =>
                  allOnChangeHandler("phone", target.value)
                }
                value={DispatchOrderStateData.phone || ""}
                id="standard-basic"
                label="PHONE"
                variant="standard"
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError.phone && addressError.phone}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <span className="due-time-text-style">
              DRIVER DETAILS (OPTIONAL)
            </span>
          </div>
          <div className="row mt-3">
            <div className="col-md-3">
              <TextField
                className="depot-form-textfields-style"
                value={DispatchOrderStateData.vrn}
                id="standard-basic"
                label="VRN"
                onChange={({ target }) =>
                  allOnChangeHandler("vrn", target.value)
                }
                variant="standard"
              />
            </div>

            <div className="col-md-3">
              <TextField
                className="depot-form-textfields-style"
                value={DispatchOrderStateData.vehicleModel}
                id="standard-basic"
                label="VEHICLE TYPE"
                onChange={({ target }) =>
                  allOnChangeHandler("vehicleModel", target.value)
                }
                variant="standard"
              />
            </div>
            <div className="col-md-3">
              <TextField
                type="string"
                className="depot-form-textfields-style"
                value={DispatchOrderStateData.driverName}
                id="standard-basic"
                label="DRIVER NAME"
                onChange={({ target }) =>
                  allOnChangeHandler("driverName", target.value)
                }
                variant="standard"
              />
            </div>

            <div className="col-md-3">
              <TextField
                type="string"
                className="depot-form-textfields-style"
                value={DispatchOrderStateData.driverContact}
                id="standard-basic"
                label="DRIVER CONTACT"
                onChange={({ target }) =>
                  allOnChangeHandler("driverContact", target.value)
                }
                variant="standard"
              />
              <div className="errors-msg-shown-for-goodsin">
                {addressError.driverContact && addressError.driverContact}
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-3 col-lg-2">
              <span className="req-text-style">REQUIREMENTS</span>
            </div>
            <div className="col-md-10 col-lg-10">
              <span className="req-msg-text-style">
                All items must belong to the same depot. For deliveries from
                multiple depots, make serarate dispatch orders
              </span>
            </div>
          </div>

          <div className="row align-items-center mt-4">
            <div className="col-md-4 d-flex flex-column">
              <FormControl variant="standard" style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-standard-label">
                  SELECT DEPOT HERE
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  onChange={({ target }) => handleDepotNameChange(target.value)}
                  label="SELECT DEPOT HERE"
                  value={selectedDepot || ""}
                >
                  {allItemsByDepotId.length > 0 &&
                    _.orderBy(allItemsByDepotId, ["name"], ["asc"]).map(
                      (item, index) => {
                        return (
                          <MenuItem key={index} value={item.depotId}>
                            {item.name}
                          </MenuItem>
                        );
                      }
                    )}
                </Select>
                <div>
                  <span className="errors-msg-shown-for-goodsin">
                    {depotSelectError && depotSelectError}
                  </span>
                </div>
              </FormControl>
            </div>
            <div
              className="col-md-8"
              style={{ position: "relative", marginTop: 18 }}
            >
              <input
                style={{ position: "relative", width: "100%" }}
                className="search-input-for-depot-personal-tab"
                type="text"
                placeholder="Search by item number..."
                value={searchValue}
                onChange={handleSearchInputChange}
              />
              {searchValue !== "" ? (
                <Close
                  style={{ cursor: "pointer" }}
                  onClick={handleClearSearchText}
                  className="search-icon-depotpersonal-style"
                />
              ) : (
                <Search className="search-icon-depotpersonal-style" />
              )}
            </div>
          </div>

          <div className="mt-2">
            <div className="table-responsive" style={{ maxHeight: "350px" }}>
              <table className="table">
                <thead style={{ position: "sticky", top: "0px" }}>
                  <tr>
                    <th>
                      <span className="items-table-text">ITEMS</span>
                    </th>
                    <th>
                      <span className="items-table-text">DAMAGED</span>
                    </th>
                    <th>
                      <span className="items-table-text">DESCRIPTION</span>
                    </th>
                    <th>
                      <span className="items-table-text">UNITS</span>
                    </th>
                    <th>
                      <span className="items-table-text">LOADED QTY</span>
                    </th>
                    <th style={{ paddingLeft: "50px" }}>
                      <span className="items-table-text">ADD</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {newFilteredArray?.length > 0 ? (
                    _.orderBy(
                      newFilteredArray || [],
                      ["itemNumber"],
                      ["asc"]
                    )?.map((item, index) => {
                      return (
                        <tr>
                          <td>{item.itemNumber}</td>
                          <td>{item.condition}</td>
                          <td>{item.description}</td>
                          <td>
                            {item?.availableQty - (item?.loadingUnit || 0)}
                          </td>
                          <td>
                            <input
                              className="search-input-for-depot-personal-tab unit-item-range-style"
                              onChange={({ target }) => {
                                if (isNumber(target.value)) {
                                  setHighlightedRow(null);
                                  const cloneAvailableData =
                                    _.cloneDeep(filteredItemsArray);
                                  let FindIncrementData = _.findIndex(
                                    cloneAvailableData,
                                    (d) => d.itemNumber === item?.itemNumber
                                  );
                                  cloneAvailableData[FindIncrementData][
                                    "loadingUnit"
                                  ] = parseInt(target.value);
                                  let Value =
                                    parseInt(
                                      cloneAvailableData[FindIncrementData]
                                        ?.availableQty
                                    ) -
                                    parseInt(
                                      cloneAvailableData[FindIncrementData]
                                        ?.loadingUnit || 0
                                    );
                                  if (Value >= 0) {
                                    setFilteredItemsArray([
                                      ...cloneAvailableData,
                                    ]);
                                  } else {
                                    cloneAvailableData[FindIncrementData][
                                      "loadingUnit"
                                    ] = parseInt(
                                      cloneAvailableData[FindIncrementData]
                                        ?.availableQty
                                    );
                                    setFilteredItemsArray([
                                      ...cloneAvailableData,
                                    ]);
                                  }
                                }
                              }}
                              onKeyDown={handleKeyPress}
                              placeholder="Units"
                              type="number"
                              value={item?.loadingUnit || ""}
                              maxLength="3"
                              style={{
                                width: "70px",
                                height: 20,
                                marginTop: 5,
                                border:
                                  highlightedRow == index
                                    ? "1px solid red"
                                    : "",
                              }}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              style={{ cursor: "pointer" }}
                              className="add-item-button-style"
                              onClick={() =>
                                handleAddItemClick(item.id, index, item)
                              }
                            >
                              <img
                                src={IconNewRecord}
                                className="me-1"
                                width={15}
                                height={15}
                                alt="new"
                              />
                              ADD
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colspan="6" className="text-center">
                        No records found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="table-responsive mt-3" style={{ maxHeight: "350px" }}>
            <Divider
              variant="fullWidth"
              component="div"
              style={{
                backgroundColor: "blue",
                height: "2px",
                marginBottom: "1rem",
                marginTop: "1rem",
              }}
            />
            <table className="table goodsin-table table-borderless p-0">
              <thead>
                <tr>
                  <th style={{ position: "sticky", top: "0px" }}>
                    <span className="items-table-header-count">
                      {selectedItemsArray?.length || 0}
                    </span>
                    <span className="items-table-text"> ITEMS</span>
                  </th>
                  <th>
                    <span className="items-table-header-count">
                      {damageCount}
                    </span>
                    <span className="items-table-text"> DAMAGED</span>
                  </th>
                  <th>DESCRIPTION</th>
                  <th>
                    <span className="items-table-header-count">
                      {unitsCount}
                    </span>
                    <span className="items-table-text"> UNITS</span>
                  </th>
                  <th>
                    <span className="items-table-text"> LOADED QTY</span>
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody className="goods-table-body">
                {selectedItemsArray &&
                  selectedItemsArray[0] &&
                  _.orderBy(
                    selectedItemsArray || [],
                    ["itemNumber"],
                    ["asc"]
                  ).map((item, index) => {
                    return (
                      <tr key={index} className="goodsin-items-tr">
                        <td>{item.itemNumber}</td>
                        <td>{item.condition}</td>
                        <td>{item.description}</td>
                        <td>
                          <input
                            className="search-input-for-depot-personal-tab unit-item-range-style"
                            onChange={({ target }) =>
                              handleRemoveQuantityonedit(target.value, item)
                            }
                            onKeyDown={handleKeyPress}
                            placeholder="Units"
                            type="number"
                            value={item.quantity || ""}
                            style={{
                              width: "70%",
                              height: 25,
                              marginTop: 5,
                              border:
                                highlightedRow == index ? "1px solid red" : "",
                            }}
                          />
                        </td>
                        <td>{item?.loadedQuantity || 0}</td>
                        {!item?.loadedQuantity && (
                          <td>
                            <div
                              className="d-flex justify-content-center align-items-center"
                              onClick={() =>
                                handleRemoveItemIconClickFromTable(item)
                              }
                            >
                              <RemoveCircleOutlineOutlinedIcon
                                className="remove-item-icon-color"
                                style={{ cursor: "pointer" }}
                                fontSize="20"
                              />
                              <span
                                className="ms-1 remove-item-label-color"
                                style={{
                                  fontFamily: "Montserrat-Regular",
                                  fontSize: 10,
                                  cursor: "pointer",
                                }}
                              >
                                REMOVE
                              </span>
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div
            className="d-flex flex-row justify-content-between"
            style={{ marginTop: 10, marginBottom: 20 }}
          >
            <Button
              variant="outlined"
              className="btn-bootstrap-submit-style"
              style={{ color: "red", borderColor: "red" }}
              startIcon={<CancelIcon />}
              onClick={() => handleClose()}
            >
              Cancel
            </Button>
            {!editData ? (
              <Button
                disabled={addNewDispatchOrderLoadingState ? true : false}
                variant="outlined"
                className={`btn-bootstrap-submit-style ${addNewDispatchOrderLoadingState ? "fade-out" : ""
                  }`}
                startIcon={<CheckCircleIcon />}
                type="submit"
              >
                Submit
              </Button>
            ) : (
              <Button
                variant="outlined"
                className="btn-bootstrap-submit-style"
                startIcon={<CheckCircleIcon />}
                type="submit"
              >
                Save
              </Button>
            )}
          </div>
        </form>
      </div>
    </>
  );
};